import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { APP_CONFIG } from '../../core/config/app-config.token';

export const apiKeyInterceptor: HttpInterceptorFn = (request, next) => {
  const { apiKey } = inject(APP_CONFIG).api;

  if (apiKey === null || apiKey.length === 0) {
    return next(request);
  }

  return next(request.clone({ setHeaders: { 'X-API-Key': apiKey } }));
};
